import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";

import SettingsActions from "./actions";
import Button from "components/Button";
import ToggleSwitch from "components/ToggleSwitch";
import getVar from "constants/.";

import "./style.scss";

const SUBSCRIPTIONS_LIST = [
  {
    name: "Order",
    label: "ORDERS"
  },
  {
    name: "Factuur",
    label: "INVOICES"
  },
  {
    name: "Levering",
    label: "DELIVERIES_HEADER"
  },
  {
    name: "Rekening overzicht",
    label: "ACCOUNT_STATEMENTS"
  }
];

interface IProps {
  getNotifications: () => void;
  settings: any;
  setNotifications: (any) => void;
  getAccount: () => void;
  intl: any;
}

interface IState {
  subscriptions: any[];
}

class Settings extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    const { accountId, subscriptions } = this.props.settings;
    this.state = {
      subscriptions: subscriptions || []
    };
  }

  public componentDidMount() {
    this.props.getAccount();
    const { accountId } = this.props.settings;
    if (accountId && !this.props.settings.accountId) {
      this.props.getNotifications();
    }
  }

  public componentWillReceiveProps(nextProps) {
    const { accountId, subscriptions } = nextProps.settings;
    if (accountId && !this.props.settings.accountId) {
      nextProps.getNotifications();
    }

    if (subscriptions) {
      this.setState({ subscriptions });
    }
  }

  private getName = name => {
    const {
      intl: { formatMessage }
    } = this.props;
    const obj = _.find(SUBSCRIPTIONS_LIST, ["name", name]);
    return obj ? formatMessage({ id: obj.label }) : name;
  };

  private toggleActive(id) {
    const subscriptions = [...this.state.subscriptions];
    const index = _.findIndex(subscriptions, ["Id", id]);
    const changedItem = { ...subscriptions[index] };
    changedItem.Active = !changedItem.Active;
    subscriptions[index] = changedItem;
    this.setState({ subscriptions });
  }

  public render() {
    const {
      setNotifications,
      intl: { locale }
    } = this.props;
    const { subscriptions } = this.state;
    const url = `${getVar(
      "AUTHORITY_URL"
    )}/account/forgotpassword?appId=${getVar(
      "CLIENT_ID"
    )}&languageCode=${locale}`;

    return (
      <div id="settings-page">
        <FormattedMessage id="SETTINGS" tagName="h1" />
        <div>
          <div className="settings-row">
            <FormattedMessage id="SETTINGS_DOCUMENTS" />
          </div>
          {subscriptions &&
            subscriptions.map(item => (
              <div className="settings-row" key={item.Id}>
                <label className="notification-field">
                  {this.getName(item.Name)}
                </label>
                <ToggleSwitch
                  on={item.Active}
                  onClick={() => this.toggleActive(item.Id)}
                />
              </div>
            ))}
          <div className="settings-btn">
            <Button
              kind="primary"
              onClick={() => setNotifications(subscriptions)}
            >
              SAVE_CHANGES
            </Button>
          </div>
        </div>
        <hr />
        <div>
          <div className="settings-row">
            <FormattedMessage id="SETTINGS_PASSWORD" />
          </div>
          <div className="settings-btn">
            <a href={url} target="_blank">
              <Button kind="primary">CHANGE_PASSWORD</Button>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    settings: state.settings
  }),
  {
    getNotifications: SettingsActions.getNotifications,
    setNotifications: SettingsActions.setNotifications,
    getAccount: SettingsActions.getAccount
  }
)(injectIntl(Settings));
